import React from 'react'
import PageTitle from '../global/PageTitle/PageTitle'
export default function TransferHeader() {
  return (
    <div class ="TransferHeader">
       <PageTitle title="Change Job" />
      <div className="header-content">
      <div class="hgl">
     Changing time type (from part time to full time or vice versa) or employee type (regularto seasonal or vice versa) for non slaried team member? Use the Edit process.
      </div>
      <a className="job-header-link" href="#">click here for Time Type Change instructions</a><br/>
      <a className="job-header-link" href="#">click here for Employee Type Change instructions</a><br/>
      <div class="hgl"> Use the Change Job Process for :
      <ul><li>Job Profile Changes</li>
      <li>Time Type Changes for Salaried Team Members</li>
      <li>Location Changes</li>
      <li>Manager Changes</li></ul></div><br/><br/><br/>
     <div className='line'> Please enter the details for your team member's job change.Contact your HR Specialist if you have any questions</div>
      
      <br/>
      </div>
      <br/><br></br>
      <hr/><br/>
    </div>
  )
}
